export const config = {
  eventGroup: 'tgame_fab_v3_5_pc_20260122',
  name: '《尘白禁区》3.5自往昔归还FAB页PC端',
  identify: 'tgame',
  eventTags: ['fab', 'v3_5', 'pc', 'tgame']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [title] - 浏览对应页面时上报页面名称，如0首页|字符串
     */
    exposePage: function(title) {
      report({
        eventName: 'expose_page',
        eventDescription: '页面曝光',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickGoGw: function() {
      report({
        eventName: 'click_go_gw',
        eventDescription: '点击进入官网'
      });
    },
    /**
     * @param {string} [title] - 上报点击的标题：QQ、贴吧、空间、微博、复制链接
     * @param {string} [kinds] - 上报点击来源：顶栏、抽奖任务
     */
    clickShare: function(title, kinds) {
      report({
        eventName: 'click_share',
        eventDescription: '点击分享',
        eventDataValue: {
          title: title,
          kinds: kinds
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string')
        }
      });
    },
    clickWatchVideo: function() {
      report({
        eventName: 'click_watch_video',
        eventDescription: '点击播放PV视频'
      });
    },
    clickGoRaffle: function() {
      report({
        eventName: 'click_go_raffle',
        eventDescription: '点击首页前往抽奖活动'
      });
    },
    clickGoCdk: function() {
      report({
        eventName: 'click_go_cdk',
        eventDescription: '点击首页获取CDK'
      });
    },
    /**
     * @param {string} [title] - 上报点击的标题：PC、Android、iOS、Tap
     */
    clickDownload: function(title) {
      report({
        eventName: 'click_download',
        eventDescription: '点击下载',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [status] - 立即登录后的状态：success、fail
     * @param {string} [statusReason] - 上报失败原因，成功不上报，失败以“前端+服务端”报错信息作为状态原因上报
     */
    clickLogin: function(status, statusReason) {
      report({
        eventName: 'click_login',
        eventDescription: '点击立即登录',
        eventDataValue: {
          status: status,
          status_reason: statusReason
        },
        types: {
          status: checkTypeHOF('string'),
          status_reason: checkTypeHOF('string')
        }
      });
    },
    clickGoH5game: function() {
      report({
        eventName: 'click_go_h5game',
        eventDescription: '点击【开启恒约仪式】前往H5'
      });
    },
    /**
     * @param {string} [status] - 点击抽奖后的状态：success、fail
     * @param {string} [statusReason] - 上报失败原因。成功不上报，失败以“前端+服务端”报错信息作为状态原因上报
     */
    clickRaffle: function(status, statusReason) {
      report({
        eventName: 'click_raffle',
        eventDescription: '点击抽奖',
        eventDataValue: {
          status: status,
          status_reason: statusReason
        },
        types: {
          status: checkTypeHOF('string'),
          status_reason: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报关注方式：B站、Tap、微博、QQ群、好游快爆
     * @param {string} [kinds] - 上报点击来源：抽奖任务、关注我们
     */
    clickGoFollow: function(title, kinds) {
      report({
        eventName: 'click_go_follow',
        eventDescription: '点击关注',
        eventDataValue: {
          title: title,
          kinds: kinds
        },
        types: {
          title: checkTypeHOF('string'),
          kinds: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [status] - 中奖登记后的状态：success、fail
     * @param {string} [statusReason] - 上报失败原因，成功不上报，失败以“前端+服务端”报错信息作为状态原因上报
     */
    clickSubmit: function(status, statusReason) {
      report({
        eventName: 'click_submit',
        eventDescription: '点击中奖登记确认按钮',
        eventDataValue: {
          status: status,
          status_reason: statusReason
        },
        types: {
          status: checkTypeHOF('string'),
          status_reason: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [status] - 地址确认后的状态：success、fail
     * @param {string} [statusReason] - 上报失败原因，成功不上报，失败以“前端+服务端”报错信息作为状态原因上报
     */
    clickConfirm: function(status, statusReason) {
      report({
        eventName: 'click_confirm',
        eventDescription: '点击中奖登记确认弹窗-确认',
        eventDataValue: {
          status: status,
          status_reason: statusReason
        },
        types: {
          status: checkTypeHOF('string'),
          status_reason: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [passport] - 上报账号|字符串
     * @param {string} [kinds] - 上报网页登录组件、游戏内登录|字符串
     */
    getCbjqztAccount: function(passport, kinds) {
      report({
        eventName: 'get_cbjqzt_account  ',
        eventDescription: '免登账号授权',
        eventDataValue: {
          passport: passport,
          kinds: kinds
        },
        types: {
          passport: checkTypeHOF('string'),
          kinds: checkTypeHOF('string')
        }
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
